import styled, { css } from 'styled-components';

export const PopoverContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 24px;
    font-family: ${theme.v2.font.family.primary};
    position: relative;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 8px;
    right: 8px;
    background: ${theme.v2.colors.neutral.highPure};
    border: none;
    border-radius: 100%;
    cursor: pointer;
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    z-index: 1;
    color: ${theme.v2.colors.neutral.lowDark};

    &:hover {
      background-color: ${theme.v2.colors.neutral.highLight};
      color: ${theme.v2.colors.neutral.lowPure};
    }
  `}
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.brand.primaryMedium};
    margin: 0;
    line-height: 20px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;
    line-height: 20px;
  `}
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`;

export const StepIndicator = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;
